export enum ViewModes {
    Grid,
    List,
}
